/**
 * /dashboard/accounting/accounts/new — Create sub-account form (G_ACC2).
 *
 * Full-page form (mirrors contacts/new + items/new pattern) with:
 *   - Parent account picker (selects from active accounts)
 *   - Code + Name inputs
 *   - Type selector (locked to parent's type when parent is chosen)
 *   - Optional description
 *
 * On success: toast "Account created." + navigate back to the list.
 */

import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { AccountForm } from "@/components/accounting/account-form";
import { AccountingFeatureGate } from "@/components/accounting/accounting-feature-gate";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/accounts/new",
)({
  component: AccountNewRoute,
});

function AccountNewRoute() {
  const { tenantSlug } = useParams({ strict: false }) as {
    tenantSlug: string;
  };
  return (
    <AccountingFeatureGate>
      <AccountingModuleShell
        title="Add Account"
        description="Create a custom sub-account under an existing chart-of-accounts head."
        actions={
          <Button asChild variant="outline" size="sm" className="gap-1.5">
            <Link
              to="/app/$tenantSlug/accounting/accounts"
              params={{ tenantSlug }}
            >
              <ArrowLeft aria-hidden className="h-4 w-4" />
              Back to Accounts
            </Link>
          </Button>
        }
      >
        <AccountForm />
      </AccountingModuleShell>
    </AccountingFeatureGate>
  );
}
